import React from 'react';
import styled from "styled-components"

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Hidden from "@material-ui/core/Hidden"

import {
    NavLink as RouterLink
} from "react-router-dom";

const Link = styled(RouterLink)`
&& {
    margin: 0 16px;
    text-transform: uppercase;
    text-decoration: none;
}
`
Link.defaultProps = {
    exact: true,
    activeStyle: {
        fontWeight: "bold"
    }
}

export default () => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return <div>
        <Hidden smUp>
            <Box m={2}>
                <Button size="large" variant="contained" onClick={handleClick}>Menu</Button>
            </Box>
            <Menu
                id="menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}><RouterLink to="/">Start</RouterLink></MenuItem>
                <MenuItem onClick={handleClose}><RouterLink to="/style">Style</RouterLink></MenuItem>
                <MenuItem onClick={handleClose}><RouterLink to="/animations">Animationen</RouterLink></MenuItem>
                <MenuItem onClick={handleClose}><RouterLink to="/queerify">Queerify</RouterLink></MenuItem>
                <MenuItem onClick={handleClose}><RouterLink to="/videos">Videos</RouterLink></MenuItem>
            </Menu>
        </Hidden>
        <Hidden xsDown>
            <nav>
                <ul>
                    <Link to="/">Start</Link>
                    <Link to="/style">Style</Link>
                    <Link to="/animations">Animationen</Link>
                    <Link to="/queerify">Queerify</Link>
                    <Link to="/videos">Videos</Link>
                </ul>
            </nav>
        </Hidden>
    </div>
}